import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading,
  leftIcon,
  rightIcon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-primary-gradient text-white hover:shadow-lg hover:opacity-90 focus:ring-primary-purple border border-transparent',
    secondary: 'bg-white text-primary-purple border border-primary-purple hover:bg-gray-50 focus:ring-primary-purple',
    outline: 'bg-transparent text-white border border-white hover:bg-white/10 focus:ring-white',
    ghost: 'bg-transparent text-text-secondary hover:bg-gray-100 hover:text-text-primary focus:ring-gray-400',
    danger: 'bg-status-danger text-white hover:bg-red-700 focus:ring-red-500 border border-transparent'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-362">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-363" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-364">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-365">{rightIcon}</span>}
    </button>;
}